import appConstants from "../../../../../appConstants";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer';
import { DropdownEditor } from '@dataGrid/components/cellEditors';
import { suppressEnter } from '@dataGrid/gridUtilities';
import { openDaysCellRenderer, openDaysTooltip } from "./addUpdateAnchorPoint/DayOfWeekStatus/utils";
import { DateTimeFilter, MultiSelectFilter, StaticFilter } from '@dataGrid/components/columnFilters';
export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration(config) {
      return GridConfig.getDefaultConfiguration();
    }

    static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.AnchorPointGrid,
      keyColumn: "anchorPointName",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        cellDataType: false,
      },
      columns: [
        {
          headerName: "Status",
          field: "isSelected",
          filter: StaticFilter,
          filterParams: {
            staticOptions: [
              { text: "Enabled Anchor", value: true },
              { text: "Disabled Anchor", value: false }
            ],
          },
          minWidth: appConstants.columnWidth.AP_STATUS,
          maxWidth: appConstants.columnWidth.AP_STATUS,
          cellRenderer: ToggleRenderer,
          cellStyle: {padding: '0px 10px'}

        },
        {
          headerName: "Name",
          field: "anchorPointName",
          tooltipField: "anchorPointName",
          minWidth: appConstants.columnWidth.AP_NAME,
          filter: MultiSelectFilter,
        },
        {
          headerName: "Empty time",
          field: "emptyTime",
          minWidth: appConstants.columnWidth.W_120,
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: appConstants.DATETYPES.TIME,
          },
        },       
        {
          headerName: "Route",
          field: "routeAssigned",
          minWidth: appConstants.columnWidth.AP_ROUTE,
          editable: params => params.data.isSelected,
          cellEditor: DropdownEditor,
          cellEditorPopup: true,
          cellEditorParams: {
            isMultiSelection: true,
            noNullValue: true
          },
          //tooltipField: "routeAssigned",
          valueFormatter: params => params.value && Array.isArray(params.value) ? params.value.map(v => v.label).join(", ") : null,
          suppressKeyboardEvent: suppressEnter,
          filter: MultiSelectFilter,
        },
        {
          headerName: "DOW",
          headerTooltip:"Anchor Point applicable on the days of the week",
          valueGetter: openDaysCellRenderer,
          minWidth: appConstants.columnWidth.W_140,
          tooltipValueGetter: openDaysTooltip,
          filter: StaticFilter,
          filterParams: {
            staticOptions: appConstants.weekdayFilter,
          },
        },
        {
          headerName: "Min Equip Size",
          field: "minEquipmentSize",
          minWidth: appConstants.columnWidth.W_120,
          headerTooltip: "Minimum Equipment Size",
          filter: MultiSelectFilter,
        }, 
        {
          headerName: "Avg PUs",
          field: "avgPickup",
          minWidth: appConstants.columnWidth.W_120,
          headerTooltip: "Average PUs",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Avg Pieces",
          field: "avgPieces",
          minWidth: appConstants.columnWidth.W_120,
          headerTooltip: "Average Pieces",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Avg PSE",
          field: "avgPallets",
          minWidth: appConstants.columnWidth.W_120,
          headerTooltip: "Average Pallets",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Avg Wgt",
          field: "avgWeight",
          minWidth: appConstants.columnWidth.W_120,
          headerTooltip: "Average Weight",
          filter: MultiSelectFilter,
        },
        {
          headerName: "Dist Shipper Count",
          field: "distinctShipperCount",
          minWidth: appConstants.columnWidth.W_180,
          headerTooltip: "Distinct Shipper Count",
          filter: MultiSelectFilter,
        },
      ]
    }
  }
}
